import { QueryClientProvider } from '@tanstack/react-query';
import { ReactNode } from 'react';
import { queryClient } from '@/shared/api/queryClient';

interface QueryProviderProps {
  children: ReactNode;
}

/**
 * Provider component for TanStack Query
 * Wraps the application with QueryClientProvider to enable react-query functionality
 */
export const QueryProvider = ({ children }: QueryProviderProps) => {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};
